/** Monorepo home for Design Studio scratch applications. */
export const STUDIO_APPS_PREFIX = 'code/studio-apps';

/**
 * Baseline scratch app always provisioned on the host checkout so the shared
 * `scratch.studio` preview and target picker stay available after a fresh clone.
 */
export const DEFAULT_HOST_SCRATCH_APP_SLUG = 'application-standard';

/** Picker label for {@link DEFAULT_HOST_SCRATCH_APP_SLUG}. */
export const DEFAULT_HOST_SCRATCH_APP_DISPLAY_NAME = 'Application indépendante';

/**
 * Host-injected production read-only SQL env vars (Design Studio host → session container).
 * Never commit secret values; scaffold templates only document these names.
 */
export const DESIGN_STUDIO_PROD_RO_ENV = {
  host: 'DESIGN_STUDIO_PROD_RO_HOST',
  port: 'DESIGN_STUDIO_PROD_RO_PORT',
  user: 'DESIGN_STUDIO_PROD_RO_USER',
  password: 'DESIGN_STUDIO_PROD_RO_PASSWORD',
  database: 'DESIGN_STUDIO_PROD_RO_DATABASE',
} as const;

export type DesignStudioProdRoEnvName =
  (typeof DESIGN_STUDIO_PROD_RO_ENV)[keyof typeof DESIGN_STUDIO_PROD_RO_ENV];

export const DESIGN_STUDIO_PROD_RO_ENV_NAMES: readonly DesignStudioProdRoEnvName[] = [
  DESIGN_STUDIO_PROD_RO_ENV.host,
  DESIGN_STUDIO_PROD_RO_ENV.port,
  DESIGN_STUDIO_PROD_RO_ENV.user,
  DESIGN_STUDIO_PROD_RO_ENV.password,
  DESIGN_STUDIO_PROD_RO_ENV.database,
];

export function studioAppPathPrefix(slug: string): string {
  return `${STUDIO_APPS_PREFIX}/${slug}`;
}

export function scratchAppTargetId(slug: string): string {
  return `scratch-app:${slug}`;
}

const SCRATCH_APP_TARGET_ID_PREFIX = 'scratch-app:';

export function parseScratchAppSlugFromTargetId(targetId: string): string | undefined {
  if (!targetId.startsWith(SCRATCH_APP_TARGET_ID_PREFIX)) {
    return undefined;
  }
  const slug = targetId.slice(SCRATCH_APP_TARGET_ID_PREFIX.length);
  if (slug === '') {
    return undefined;
  }
  return slug;
}

export function isScratchAppTargetId(targetId: string): boolean {
  return parseScratchAppSlugFromTargetId(targetId) !== undefined;
}
